import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { PagedData } from '../model/paged-data';
import { Page } from '../model/page';

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class PagingServerService {
  /**
   * A method that mocks a paged server response
   * @param page The selected page
   * @returns {any} An observable containing the employee data
   */
  public getResults(page: Page,data:any): Observable<PagedData<any>> {
    return of(data)
      .pipe(map(d => this.getPagedData(page,data)))
      .pipe(delay(1000 * Math.random()));
  }

  /**
   * Package companyData into a PagedData object based on the selected Page
   * @param page The page data used to get the selected data from companyData
   * @returns {PagedData<CorporateEmployee>} An array of the selected data and page
   */
  private getPagedData(page: Page,data:any): PagedData<any> {
    const pagedData = new PagedData<any>();
    page.totalElements = data.length;
    page.totalPages = page.totalElements / page.size;
    const start = page.pageNumber * page.size;
    const end = Math.min(start + page.size, page.totalElements);
    for (let i = start; i < end; i++) {
      const jsonObj = data[i];
      
      pagedData.data.push(jsonObj);
    }
    pagedData.page = page;
    return pagedData;
  }
}
